
export const FeedbackFiltersConstants = {
	SET_FEEDBACK_FILTERS: 'SET_FEEDBACK_FILTERS',
	SET_FEEDBACK_SAVED_FILTERS: 'SET_FEEDBACK_SAVED_FILTERS',
	SET_FEEDBACK_PREVIOUS_FILTERS: 'SET_FEEDBACK_PREVIOUS_FILTERS'
}